import { ConditionalPartial } from '../../../../utils';

import { CreatePvProcessConfigRequestDto } from './create-pv-process-config.request.dto';

/**
 * DTO for updating pharmacovigilance process configuration
 * All fields are optional for partial updates
 */
export class UpdatePvProcessConfigRequestDto extends ConditionalPartial(CreatePvProcessConfigRequestDto) {}
